import type {
  AddToCrmContactType,
  PartnerContact,
} from '@/types/copilotContacts';

export function addToCrmContactFromPartnerContact(
  contact: PartnerContact['first_contact'],
): AddToCrmContactType {
  return {
    firstName: contact.first_name || null,
    lastName: contact.last_name,
    email: contact.partner_contact_email ?? '',
    phone: contact.partner_contact_phone || null,
    title: contact.partner_contact_title || null,
    isInOwnCrm: contact.in_own_crm,
    crmId: contact.crm_id ?? null,
  };
}
